module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_01_beach-photo-d432abfc3aa047a662c03e2e0e566317.jpg";